/** @jsx jsx */
import { jsx } from "theme-ui";
import Divider from "../../elements/divider";

interface SpaceTextProps {
  offset: number;
  factor?: number;
}

const SpaceText = ({ offset, factor = 1.5 }: SpaceTextProps) => (
  <Divider speed={0.2} offset={offset + 0.3} factor={factor} zIndex={15}>
    <div
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        textAlign: "center",
        zIndex: 15,
        width: ["85%", "75%", "65%"],
        animation: "fadeInUp 1.5s ease-out, floatText 6s ease-in-out infinite",
        "@keyframes fadeInUp": {
          "0%": {
            opacity: 0,
            transform: "translate(-50%, -40%)",
          },
          "100%": {
            opacity: 1,
            transform: "translate(-50%, -50%)",
          },
        },
        "@keyframes floatText": {
          "0%, 100%": {
            transform: "translate(-50%, -50%)",
          },
          "50%": {
            transform: "translate(-50%, -52%)",
          },
        },
      }}
    >
      <h3
        sx={{
          color: "heading",
          fontSize: [3, 4, 5, 6],
          fontWeight: 600,
          textShadow: [
            `0 0 8px rgba(255, 255, 255, 0.6),
            0 0 15px rgba(255, 255, 255, 0.4),
            0 0 20px rgba(255, 255, 255, 0.3)`,
            `0 0 15px rgba(255, 255, 255, 0.6),
            0 0 25px rgba(255, 255, 255, 0.4),
            0 0 35px rgba(255, 255, 255, 0.3),
            0 0 45px rgba(200, 220, 255, 0.2),
            0 0 55px rgba(186, 85, 211, 0.15)`,
          ],
          opacity: 0.95,
          letterSpacing: ["0.05em", "0.08em"],
          mb: [2, 3],
          lineHeight: 1.3,
          px: [2, 0],
        }}
      >
        Exploring the Cosmos of Code
      </h3>
      <p
        sx={{
          color: "text",
          fontSize: [1, 2, 3],
          mt: [2, 3],
          mb: [1, 2],
          opacity: 0.85,
          fontStyle: "italic",
          textShadow: [
            `0 0 6px rgba(255, 255, 255, 0.4),
            0 0 12px rgba(255, 255, 255, 0.2)`,
            `0 0 10px rgba(255, 255, 255, 0.4),
            0 0 20px rgba(255, 255, 255, 0.2)`,
          ],
          letterSpacing: ["0.02em", "0.03em"],
          lineHeight: [1.5, 1.6],
          px: [2, 0],
        }}
      >
        Journeying through the digital universe, one project at a time
      </p>
    </div>
  </Divider>
);

export default SpaceText;

